import type { Category } from '@/types/movie';

export const categories: Category[] = [
  {
    slug: '动作',
    name: '动作',
    description: '爆破、追逐与硬核对抗，让肾上腺素一路飙升的爽片集合。',
    icon: 'ri-sword-line',
  },
  {
    slug: '剧情',
    name: '剧情',
    description: '细腻刻画人物与命运，在平凡故事里照见真实的人生。',
    icon: 'ri-book-open-line',
  },
  {
    slug: '爱情',
    name: '爱情',
    description: '从初见到久别重逢，关于心动与守候的温柔瞬间。',
    icon: 'ri-heart-3-line',
  },
  {
    slug: '科幻',
    name: '科幻',
    description: '穿越星海与未来，在想象力的边界追问人类的意义。',
    icon: 'ri-planet-line',
  },
  {
    slug: '喜剧',
    name: '喜剧',
    description: '轻松解压的欢笑时刻，笑过之后还留着一点暖意。',
    icon: 'ri-emotion-happy-line',
  },
  {
    slug: '悬疑',
    name: '悬疑',
    description: '层层反转与烧脑推理，真相永远藏在最后一个镜头里。',
    icon: 'ri-search-eye-line',
  },
  {
    slug: '犯罪',
    name: '犯罪',
    description: '罪与罚的灰色地带，在暗流涌动中审视人性的分寸。',
    icon: 'ri-shield-keyhole-line',
  },
  {
    slug: '惊悚',
    name: '惊悚',
    description: '屏住呼吸的紧张张力，每一个细节都可能是陷阱。',
    icon: 'ri-alarm-warning-line',
  },
  {
    slug: '恐怖',
    name: '恐怖',
    description: '黑暗中的未知恐惧，适合胆子够大的深夜观影者。',
    icon: 'ri-ghost-line',
  },
  {
    slug: '动画',
    name: '动画',
    description: '天马行空的治愈世界，大人小孩都能找到共鸣。',
    icon: 'ri-palette-line',
  },
  {
    slug: '奇幻',
    name: '奇幻',
    description: '打破现实规则的魔法冒险，让想象力自由生长。',
    icon: 'ri-sparkling-2-line',
  },
  {
    slug: '历史',
    name: '历史',
    description: '重回时代现场，在宏大叙事中感受岁月沉淀的重量。',
    icon: 'ri-ancient-gate-line',
  },
];

export const decadeOptions = [
  { value: 'all', label: '全部年代' },
  { value: 'recent', label: '近一年' },
  { value: 'five', label: '5 年内' },
  { value: 'classic', label: '经典（5 年以上）' },
];

export const sortOptions = [
  { value: 'latest', label: '最新上映' },
  { value: 'hot', label: '最热推荐' },
  { value: 'rating', label: '评分最高' },
];